<sew-dialog
    type="{{ type }}"
    headline="{{ headline }}"
    label="{{ label }}"
    status="{{ status }}"
    open="{{ open }}"
    size="{{ size }}"
    closeButton="{{ closeButton }}"
    (close)="close()"
>
    <ng-container *ngComponentOutlet="component; injector: contentInjector"></ng-container>
</sew-dialog>
